import { prefix } from '@goldwasserexchange/react-topmodel';
export var headingSectionPrefixer = prefix('HeadingSection');
